import ModalSurvey from "./ModalSurveyContainer.vue";

export { ModalSurvey };


// WEBPACK FOOTER //
// ./src/modules/modal/Survey/index.js